import { useHotkeys } from 'react-hotkeys-hook';

import { usePlayerStore } from '../components/PlayerContextProvider';

export type UsePlayerMuteShortcutParams = {
  /**
   * The scope for the mute shortcut.
   * @see https://github.com/JohannesKlauss/react-hotkeys-hook?tab=readme-ov-file#scopes
   */
  scope: string;
};

export const usePlayerMuteShortcut = ({ scope }: UsePlayerMuteShortcutParams) => {
  const videoElement = usePlayerStore((store) => store.videoElement);

  useHotkeys(
    'm',
    () => {
      if (videoElement) {
        videoElement.muted = !videoElement.muted;
      }
    },
    {
      description: 'Toggle mute',
      enabled: !!videoElement,
      preventDefault: true,
      scopes: [scope],
    },
    [videoElement, scope],
  );
};
